import { Image } from "antd";
import { formatDisplayDateTime, serverImgFullPath } from "../utils/Common";
import { useEffect, useState } from "react";
import useUserStore from "../stores/store";
import { useNavigate } from "react-router-dom";
import { getBranchesRestaurantSwitch, prepareRestaurantSwitchUserData } from "../services/super-admin/restaurant-switch-service";

export default function RestaurantSwitchItemComponent({
  record = {
    id: "",
    _name: "",
    status: "",
    logo: "",
  },
  parentRestaurants
}) {
  const navigate = useNavigate();
  const { user, setUser, setIsReloadNeeded, showNotification } = useUserStore();
  const [branches, setBranches] = useState([]);
  
  const [loading, setLoading] = useState(false);

  async function handleSwitch(parentRestaurantId) {
    const userData = prepareRestaurantSwitchUserData(user, parentRestaurantId)

    if (!userData) {
      showNotification('Sorry. No active branch found for this restaurant.');
      return;
    }

    setUser(userData);
    
    navigate('/dashboard');
    setIsReloadNeeded(true);
  }

  useEffect(() => {
    const tmpBranches = getBranchesRestaurantSwitch(record.id, parentRestaurants);
    setBranches(tmpBranches);
  }, [])

  return (
    <section className="my-3 px-5 bg-[#F1F1F1] rounded-lg">
      <div className="w-full h-auto flex items-center space-x-[10px] py-2">
        <div className="mr-[63px] flex items-center rounded-full">
          <Image
            src={serverImgFullPath(record.logo, "/images/temp-res-logo2.png")}
            alt="res-logo"
            width={85}
            height={85}
            className="rounded-full"
            fallback={"/images/temp-res-logo2.png"}
          />
        </div>

        {/* Restaurant Details */}
        <div className="w-full h-auto flex items-center">
          <div className="w-[70%]">
            <h1
              className="font-[700] text-xl text-[#696969] font-p_bold 
              text-[18px] leading-[14.4px] break-words break-all whitespace-normal leading-snug">
              {record._name}
            </h1>
            <div className="pt-5 text-sm">{formatDisplayDateTime(record.createdAt)}</div>
          </div>

          {/* Date, Status, and Buttons */}
          <div className="flex justify-between items-center w-full">
            {/* Date */}
            <div className="text-center">
              <h1
                className="font-[700] text-base text-[#696969] font-p_bold 
                  text-[18px] leading-[14.4px]"
              >
                Total Branch # {branches.length}
              </h1>
              {branches.map((item, i) => (<div key={item.branch}>
                {item.branch}
              </div>))}
            </div>

            {/* Status */}
            <div className="flex justify-center items-center">
              {record.status === "Published" ? (
                <div
                  className="capitalize font-p_bold text-[14px] 
                    leading-[16px] tracking-[0.58px] text-[#FCBD10] px-2 text-center"
                >
                  Published
                </div>
              ) : (
                <div className="capitalize font-[500] text-lg text-red-500 px-2 text-center">
                  Pending
                </div>
              )}
            </div>

            {/* Buttons */}
            <div className="flex space-x-[6px]">
              <button
                className="h-[42px] w-[100px] bg-[#2EC12B] text-white text-[14px] font-bold leading-[16px] rounded-lg"
                onClick={() => handleSwitch(record.id)}
              >
                Operate
              </button>
            </div>
          </div>
        </div>
      </div>      
    </section>
  );
}
